import Search from "./Search";

const Delibery = {
  Search,
};
export default Delibery;
